<template>
  <div style="padding: 0.8rem 1rem">
    <div class="row align-items-center" style="cursor: pointer;" @click="toggleDetails">
      <div class="col-11">
        <p class="mb-0 fw-medium">{{ client.client ? client.client.company : "Unknown" }}</p>
      </div>
      <div class="col-1 text-end">
        <i class="fa" :class="[selected == clientId ? 'fa-chevron-down' : 'fa-chevron-right']"></i>
      </div>
    </div>

    <div v-if="selected && selected == clientId && lines.length >= 1" class="mt-3 mb-2">
      <div class="row row-cols-4 fw-semibold text-muted small mb-1 px-2">
        <div class="col-5">Description</div>
        <div class="col-2">Type</div>
        <div class="col-2">Rate</div>
        <div class="col-3 text-end">Hours</div>
      </div>

      <ul class="list-unstyled mb-0">
        <li
          is="lines"
          v-for="(line, index) in lines"
          :key="line.description"
          :line="line"
          :index="index"
          @toggleInclude="toggleInclude"
          @notBillable="notBillable"
        ></li>
      </ul>

      <div class="row mt-3 align-items-center">
        <div class="col">
          <button
            v-if="clientId != '-1' && (getStandardHours > 0 || getUrgentHours > 0)"
            type="button"
            class="btn btn-primary"
            @click="handleCreateInvoice"
          >
            Create Invoice
          </button>
        </div>
        <div class="col-auto text-end text-muted small">
          Standard: <strong>{{ getStandardHours }} hrs</strong>
          &nbsp;&nbsp;
          Urgent: <strong>{{ getUrgentHours }} hrs</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { notify } from 'utils'
import Lines from './_lines'

export default {
  props: ['client'],

  data: function () {
    return {
      filters: {},
    }
  },

  computed: {
    ...mapState('uninvoiced', ['selected', 'lines']),
    ...mapGetters('uninvoiced', ['getStandardHours', 'getUrgentHours']),

    clientId() {
      return this.client.client ? this.client.client.id : '-1'
    }
  },

  methods: {
    ...mapActions('uninvoiced', ['getLines', 'clearSelected', 'includeLine', 'setNotBillable', 'createInvoice']),

    toggleDetails() {
      if (this.selected == this.clientId) {
        this.clearSelected()
      } else {
        this.getLines(this.clientId)
      }
    },

    toggleInclude(index, value) {
      this.includeLine({ value: !value, index })
    },

    handleCreateInvoice() {
      this.createInvoice().catch((error) => {
        if (error.response && error.response.status === 403) {
          notify.error('You are not authorized to perform this action.')
        } else {
          notify.error('Failed to create invoice.')
        }
      })
    },

    notBillable(index) {
      var that = this

      return this.$swal({
        title: 'Confirm not billable',
        html: 'Are you sure this item is non-billable?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
      }).then(function () {
        that.setNotBillable(index).catch((error) => {
          if (error.response && error.response.status === 403) {
            notify.error('You are not authorized to perform this action.')
          } else {
            notify.error('Failed to mark as not billable.')
          }
        })
      }, function () {
        // Cancelled
      })
    }
  },

  components: {
    Lines
  }
}
</script>
